import React, { useMemo } from "react"
import { useParams } from "react-router-dom"
import Screen from 'shared/Components/Skeleton/Screen'
import { Localized } from "@fluent/react"
import { AddDeliveryTopBar } from "../Components/Layouts/AddDeliveryTopBar"
import { Grid, makeStyles } from "@material-ui/core"
import { Roboto } from "shared/theme"
import { useDispatch, useSelector } from "react-redux"
import { WellknownHeight } from "../../../Helpers/constants"
import { selectUserCanteenId } from "../../User/userSelectors"
import DeliveryFormWrapper from "../Components/Layouts/DeliveryFormWrapper"
import { IMeetingPlanningState } from "../Redux/MeetingPlanningReducer"

const useStyles = makeStyles((theme) => ({
    root: {
        paddingTop: "1.6rem",
        paddingBottom: WellknownHeight.FLOATING_BUTTON_CLEARANCE + theme.spacing(2)
    },
    title: {
        color: "#505050",
        fontFamily: Roboto,
        fontSize: "1.0625rem",
        fontWeight: "bold",
        letterSpacing: "0.1px",
        textAlign: "center",
        display: "block",
        margin: 0
    },
}))

interface IRouteParams {
    deliveryId?: string
}

export function MeetingPlanningScreen({ initialDeliveryForm, meetingPlaningDeliveries }: IMeetingPlanningState) {
    const classes = useStyles()

    const { deliveryId } = useParams<IRouteParams>();
    const userCanteenId = useSelector(selectUserCanteenId)
    const dispatch = useDispatch()
    const isInitialShow = useMemo(() => Boolean(!meetingPlaningDeliveries?.length || meetingPlaningDeliveries.find(delivery => delivery.id === deliveryId)?.isInitial), [deliveryId, meetingPlaningDeliveries])

    return (
        <Screen
            name='MeetingBookingScreen'
            fitPage
            alternativeHeaderElement={
                <AddDeliveryTopBar
                    dispatch={dispatch}
                    middleElement={
                        <Localized id="meeting-planning-screen-title">
                            <span className={classes.title}>Tilføj levering af mødetjenester</span>
                        </Localized>
                    }
                />
            }
        >
            <Grid container direction="column" spacing={1} className={classes.root}>
                        <DeliveryFormWrapper
                            deliveryId={deliveryId || null}
                            isInitialShow={isInitialShow}
                            initialDeliveryForm={initialDeliveryForm}
                            meetingPlaningDeliveries={meetingPlaningDeliveries}
                            userCanteenId={userCanteenId}
                            dispatch={dispatch}
                        />
            </Grid>
        </Screen>
    )
}
